<template>
  <div>
    <div class="top-hero2 flex justify-center">
      <div class="w-full sm:w-8/12 sm:mt-8 text-center rounded-lg">
        <div class="overflow-hidden content-center mt-12 sm:mt-0">
          <div class="w-full">
            <div class="card">
              <div>
                <img
                  class="w-full object-cover"
                  src="https://homesby360.s3.amazonaws.com/bg2.jpg"
                  alt="homesby360"
                />
              </div>
              <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
                  <div class="flex">
                    <img
                      class="h-24 w-24 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
                      src="../assets/Nicola.png"
                      alt="RealtorImage"
                    />

                    <div class="mt-12 sm:mt-8 ml-4">
                      <h1
                        class="text-lg sm:text-2xl font-bold text-gray-700 truncate"
                      >
                        Nicola Burger (Broker in Charge) <br />
                        <!-- <button type="button" class="inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                  <i class="fas fa-play-circle -ml-0.5 mr-2 h-4 w-4"></i>
                                  Watch Intro
                                </button> -->
                      </h1>
                    </div>
                  </div>
                </div>

                <p
                  class="mt-2 font-weight-light mx-auto text-lg sm:text-xl text-center text-gray-500"
                >
                  <span class="uppercase text-4xl"
                    >Hello and welcome to 360 Real Estate!
                  </span>
                  <br />
                  My name is Nicola Burger, I am the Broker in Charge and have
                  become a local area expert in my 10+ years of working Real
                  Estate in North Carolina. I look forward to showing you why
                  360 Real Estate is your best choice and helping you get your
                  dream home!
                </p>
              </div>
            </div>

            <div class="bg-light p-2">
              <v-card-text>
                <v-form v-model="valid">
                  <div class="row">
                    <div class="col">
                      <v-text-field
                        :counter="10"
                        required
                        :rules="nameRules"
                        label="First Name"
                        name="name"
                        v-model="contact.first_name"
                        prepend-icon="mdi-account"
                        type="text"
                      ></v-text-field>
                    </div>

                    <div class="col">
                      <v-text-field
                        label="Last Name"
                        :rules="lastNameRules"
                        :counter="10"
                        required
                        name="last_name"
                        v-model="contact.last_name"
                        prepend-icon="mdi-account"
                        type="text"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <v-text-field
                        :rules="phoneRules"
                        :counter="12"
                        required
                        label="Phone Number"
                        name="phone"
                        v-model="contact.phone"
                        prepend-icon="mdi-account"
                        type="text"
                      ></v-text-field>
                    </div>

                    <div class="col">
                      <v-text-field
                        label="Email"
                        name="email"
                        :rules="emailRules"
                        required
                        v-model="contact.email"
                        prepend-icon="mdi-account"
                        type="email"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <v-text-field
                      :counter="100"
                      required
                      :rules="addressRules"
                      label="Address"
                      name="address"
                      v-model="contact.address"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
                  </div>

                  <div>
                    <v-radio-group
                      :rules="[v => !!v || 'You must select to continue!']"
                      required
                      v-model="contact.selected"
                    >
                      <v-radio label="Buy A Home" value="Buyer"></v-radio>
                      <v-radio label="Sell A Home" value="Seller"></v-radio>
                      <v-radio
                        label="Property Management"
                        value="Management"
                      ></v-radio>
                      <v-radio label="Find A Rental" value="Rent"></v-radio>
                    </v-radio-group>
                  </div>

                  <v-textarea
                    v-model="contact.message"
                    required
                    :rules="messageRules"
                    :counter="150"
                    solo
                    label="Message"
                    rows="4"
                  ></v-textarea>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  id="welcomeContact"
                  class="text-white"
                  color="#42A5F5"
                  :disabled="!valid"
                  @click.prevent="sendMessage"
                  >Send Message</v-btn
                >
              </v-card-actions>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block sm:hidden my-16"></div>
  </div>
</template>

<script>
export default {
  props: {
    source: String
  },

  data() {
    return {
      valid: false,
      contact: {
        first_name: "",
        last_name: "",
        address: "",
        email: "",
        phone: "",
        selected: "",
        message: ""
      },

      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],

      lastNameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],

      addressRules: [
        v => !!v || "Address is required",
        v => v.length <= 100 || "Phone must be less than 100 characters"
      ],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],

      phoneRules: [
        v => !!v || "Phone is required",
        v => v.length <= 12 || "Phone must be less than 12 characters"
      ],

      messageRules: [
        v => !!v || "Name is required",
        v => v.length <= 150 || "Message must be less than 150 characters"
      ]
    };
  },

  methods: {
    sendMessage() {
      window.axios.post("/api/messages", this.contact).then(() => {
        this.contact = {};
        alert("Message Sent");
        this.$router.push({ name: "Home" });
      });
    }
  }
};
</script>

<style>
#challange-target {
  display: none;
}

@media (max-width: 1026px) {
  #challange-target {
    display: block;
    margin-top: 65px;
    color: transparent;
  }
}
</style>
